import { LOAD_ENTITIES_UPDATED, LOAD_ENTITIES_UPDATED_SUCCESS } from '../../constants/ActionTypes';

export const loadEntitiesUpdated = () => ({
  type: LOAD_ENTITIES_UPDATED,
  payload: {
    resource: 'companies/entities',
    onSuccess: loadEntitiesUpdatedSuccess,
    method: 'GET',
  },
});

export const loadEntitiesUpdatedSuccess = (entitiesUpdatedResponse) => ({
  type: LOAD_ENTITIES_UPDATED_SUCCESS,
  payload: entitiesUpdatedResponse,
});
